import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpContentText: {
    defaultMessage:
      'Upload a CSV file to create custom packages. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>',
    id: 'ehCA/R',
    description: 'Custom Package Import help content text',
  },
  uploadFile: {
    defaultMessage: 'Upload File',
    id: '8cjYM6',
    description: 'Title for the first step of the import process',
  },
});
